import { LoginEvent } from '@/usecases/event-bus-for-third-party/event'
import { DataLayerService } from '@/vendor/gtm/data-layer'
import { loginEventFactory } from '@/vendor/gtm/events/ga4/login'

export function handleLoginEvent(_event: LoginEvent): void {
  new DataLayerService().push(loginEventFactory.create())
}
